import React from 'react'
import { observer } from 'mobx-react-lite'
import referralsPreviewImg from 'shared/assets/images/referrals/referrals_preview.png'
import { EmptyState, Typography } from 'shared/ui'
import { LINK_AFFILIATE_AGREEMENT_HELP, LINK_REFERRALS_HELP_GUIDE } from 'shared/constants/links'
import { getCDNAssetURL } from 'shared/lib'
import { ReferralsActions } from 'pages/settings/pages/referrals/pages/ReferralsView/ui/ReferralsActions/ReferralsActions'
import styles from './styles.module.scss'

export const ReferralsEmpty = observer(() => {
  return (
    <>
      <EmptyState
        title={
          <span className={styles.title}>
            <a
              href={LINK_REFERRALS_HELP_GUIDE}
              target='_blank'
              rel='noreferrer'
              className={styles.previewImageContainer}
            >
              <img alt='Referrals preview' src={getCDNAssetURL(referralsPreviewImg)} />
            </a>
            <Typography variant={'heading-lg'} ariaLabel={'ReferralsTitle'}>
              Refer a friend. Get $50.
            </Typography>
          </span>
        }
        text='When your friend spends $50 with Salesmsg, you’ll earn $50.'
        actions={<ReferralsActions />}
        typographyProps={{
          variant: 'body-lg-regular',
          ariaLabel: 'ReferralsText',
          className: styles.subTitleText,
        }}
        boxProps={{
          gap: '20px',
          width: 'unset',
          height: '100%',
        }}
        noIcon
        subText={
          <Typography
            ariaLabel='ReferralsTermsAndConditions'
            variant='body-md-regular'
            color={'var(--content-primary-tertiary)'}
            className={styles.terms}
            marginTop={12}
          >
            By clicking “Start referring” you agree to
            <br />
            <a href={LINK_AFFILIATE_AGREEMENT_HELP} target={'_blank'} rel='noreferrer'>
              Partner Referral Program Terms and Conditions
            </a>
          </Typography>
        }
      />
    </>
  )
})
